// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_pageContainer__VH7It {
  --brand-yellow: #EEB547;
  --brand-yellow-hover: #F5C564;
  --brand-yellow-rgb: 238, 181, 71;
  background-color: var(--background-color0);
  color: var(--text-color0);
  transition: background-color 0.3s ease, color 0.3s ease;
  min-height: 100vh;
  font-family: var(--Raleway), sans-serif;
  overflow-x: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/pages/public/CadastroLoja/styles.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,0CAA0C;EAC1C,yBAAyB;EACzB,uDAAuD;EACvD,iBAAiB;EACjB,uCAAuC;EACvC,kBAAkB;AACpB","sourcesContent":[".pageContainer {\n  --brand-yellow: #EEB547;\n  --brand-yellow-hover: #F5C564;\n  --brand-yellow-rgb: 238, 181, 71;\n  background-color: var(--background-color0);\n  color: var(--text-color0);\n  transition: background-color 0.3s ease, color 0.3s ease;\n  min-height: 100vh;\n  font-family: var(--Raleway), sans-serif;\n  overflow-x: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": `styles_pageContainer__VH7It`
};
export default ___CSS_LOADER_EXPORT___;
